import { useI18n } from "@baton/i18n";
import { Sparkles } from "@baton/icons";
import { ariaKeyShortcuts } from "@baton/ui";

/**
 * The rail's Assistant tile (015 FR-015-180, `contracts/design-system.md` § The shell, the bottom
 * cluster, 2026-10-14): the same box as the mode tiles in the bottom cluster above Help, Lucide
 * `sparkles` over the word Assistant, a toggle carrying `aria-pressed` and drawn in the active tile's
 * fill with no indicator bar while the panel is open, since it opens a panel and is no mode, with
 * `Mod+J` in its `aria-keyshortcuts`. It is drawn only where the panel can open (the feature on and
 * the web text surface on), rather than drawn and refused.
 */
export function AssistantTile({ open, onToggle }: { readonly open: boolean; readonly onToggle: () => void }) {
  const { t } = useI18n();
  return (
    <button type="button" className="b-rail__item" data-glide-row data-assistant-tile aria-pressed={open} aria-keyshortcuts={ariaKeyShortcuts("Mod+J")} onClick={onToggle}>
      <Sparkles aria-hidden="true" />
      <span className="b-rail__label">{t("nav.assistant")}</span>
    </button>
  );
}
